import React from 'react';
import ReactDOM from 'react-dom';
import EventsSignUpApp from './EventsSignUpApp/EventsSignUpApp';
import EventsCancelApp from "./EventsCancelApp/EventsCancelApp";
import EventsContactApp from "./EventsContactApp/EventsContactApp";
import {EventUserRegistration, OptionLabelValue} from "./interfaces";
import {getJSONFromHtml} from "../../domain/common";
import {format} from "date-fns";

const init = () => {
    const $rootRegApp = document.getElementById('events-reg-app');
    if ($rootRegApp) {
        const dataUser =getJSONFromHtml(document.getElementById('events-reg-data')) as EventUserRegistration;
        const subEventsList =getJSONFromHtml(document.getElementById('events-reg-subevents-data-data')) ;
        const eventType = (document.getElementById('event-type')?.textContent || '')?.trim().toLowerCase() ;
        const eventID = parseInt((document.getElementById('event-id')?.textContent || '')?.trim().toLowerCase());
        var ddlSubEvents: OptionLabelValue[] = [];
        if(subEventsList) {
            ddlSubEvents =  [{label: 'Select ...', value: 0, id: 0, subEvents: null}];
            subEventsList.forEach((se: any) => {
                if(se["subEventStatusName"] && se["subEventStatusName"] !== '')
                    return;
                
                const _value = se["subEventID"];
                let _label = (format(new Date(se["subEventDate"]), 'EEEE, MMMM d, yyyy') + ' - ' + se["subEventLocation"]) as string;
                const _id = se["eventID"];

                let ddlObj: OptionLabelValue = {value: _value, label: _label, id: _id,subEvents: null};
                ddlSubEvents.push(ddlObj);
            });
        }

        //console.log('dataUser: ',dataUser);
        //console.log('subEventsList: ',subEventsList);
        //console.log('ddlSubEvents: ',ddlSubEvents);
        //console.log('eventType: ',eventType);
        ReactDOM.render(
            <EventsSignUpApp dataUser={dataUser} subEventsList={ddlSubEvents} eventType={eventType} eventID={eventID} />,
            $rootRegApp
        );
    }

    const $rootCancelApp = document.getElementById('events-cancel-app');
    if ($rootCancelApp) {
        const dataMessage = $rootCancelApp.getAttribute('data-message');
        ReactDOM.render(
            <EventsCancelApp  message={dataMessage}/>,
            $rootCancelApp
        );
    }


    const $rootEventsContacApp = document.getElementById('events-contact-app');
    if ($rootEventsContacApp) {
        const dataUser =getJSONFromHtml(document.getElementById('events-contact-data')) as EventUserRegistration;
        ReactDOM.render(
            <EventsContactApp  dataUser={dataUser} />,
            $rootEventsContacApp
        );
    }


};

init();